import { useMutation } from "react-query";
import { getSecurityBy } from "../../../../actions/CarrierAgreementMgmt/Security";
export const useSearchSecurity = () => {
  return useMutation(getSecurityBy);
};
export default useSearchSecurity;
